import type { GetControlGroupCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlGroupCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

export const useGetControlGroupCount = createQueryHook<
  Record<string, never>,
  number,
  GetControlGroupCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.controlGroup.controlGroupCount.queryOptions(),
  // Pass the count straight through (not `data ?? 0`): the createQueryHook
  // factory already surfaces undefined while loading, so a genuine 0 must
  // stay 0 rather than be masked by a coerced fallback.
  mapTrpcDataToGraphQL: (data) => ({
    control_group_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetControlGroupCountDocument,
});
